<template>
    <Card>
        <div style="display: flex;align-items: center;justify-content: space-between; width: 450px;">
            <RadioGroup v-model="client_type" @on-change="getList">
                <Radio label="1"><span>个人</span></Radio>
                <Radio label="2"><span>部门</span></Radio>
            </RadioGroup>
            <div>
                <span>时间周期：</span>
                <Select v-model="timePeriod" style="width:200px" @on-change="timePeriodClick">
                    <Option v-for="item in timePeriodList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
        </div>
        <div style="text-align: center; font-size: 20px;font-weight: bold;">转化分析</div>
        <div id="Mimelist2"></div>
        <div style="width: 100%;">
            <table border="1" cellspacing="0" style="width: 100%;">
                <tr>
                    <th></th>
                    <th v-for="(item,index) in table_th_list" :key="index">{{item}}</th>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                            <div style="height: 10px; width: 30px; background-color: #4473C5;"></div>
                            <span>优质率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionMy.series[0].data" :key="index">
                        {{item}}%
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                            <div style="height: 10px; width: 30px; background-color: #ED7D31;"></div>
                            <span>上门率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionMy.series[1].data" :key="index">
                        {{item}}%
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                            <div style="height: 5px; width: 30px; background-color: #A5A5A5;"></div>
                            <span>签约率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionMy.series[2].data" :key="index">
                        {{item}}%
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                            <div style="height: 5px; width: 30px; background-color: #FCCE3B;"></div>
                            <span>放款率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionMy.series[3].data" :key="index">
                        {{item}}%
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 110px;">
                            <div style="height: 5px; width: 30px; background-color: #468ECD;"></div>
                            <span>业绩</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionMy.series[4].data"
                        :key="index">{{item}}%
                    </td>
                </tr>
            </table>
        </div>
        <div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px;">上门分析</div>
        <div id="Mimelist3"></div>
        <div style="width: 100%;">
            <table border="1" cellspacing="0" style="width: 100%;">
                <tr>
                    <th width="180px"></th>
                    <th v-for="(item,index) in bottomXList" :key="index">{{item}}</th>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 95px;">
                            <div style="height: 10px; width: 30px; background-color: #4372C4"></div>
                            <span>上门率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionCompare.series[0].data"
                        :key="index">{{item}}%
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex; align-items: center; justify-content: center;width: 150px;">
                            <div style="height: 10px; width: 30px; background-color: #A4A4A4;"></div>
                            <span>公司平均上门率</span>
                        </div>
                    </td>
                    <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionCompare.series[1].data"
                        :key="index">{{item}}%
                    </td>
                </tr>
            </table>
        </div>
    </Card>
</template>

<script>
    import {getDoorNums} from "../../api/statics";
	import {mapGetters} from "vuex";

	export default {
        name: "ClientVisitAnalyse",
        data() {
            return {
                table_th_list: [],
                // 下图 x坐标
                bottomXList: ['1星客户', '2星客户', '2星+客户', '3星客户', '4星客户'],
                weekDayList: [],
                yearMonthList: [],
                client_type: '1',
                timePeriod: '0',
                timePeriodList: [{
                    value: '0',
                    label: '最近7天'
                },
                    {
                        value: '1',
                        label: '最近15天'
                    },
                    {
                        value: '2',
                        label: '最近30天'
                    },
                    {
                        value: '3',
                        label: '最近1年'
                    },
                    {
                        value: '4',
                        label: '最近2年'
                    },
                ],
				dataZoom: [{
					type: 'slider',
					show: true, //flase直接隐藏图形
					xAxisIndex: [0],
					left: '9%', //滚动条靠左侧的百分比
					bottom: -5,
					start: 0, //滚动条的起始位置
					end: 30 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
				}],
                // 转化分析
                optionMy: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: ['优质率', '上门率', '签约率', '放款率', '业绩'],
                        top: ''
                    },
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    },
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {
                                show: false
                            },
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [{
                        name: '优质率',
                        type: 'bar',
                        data: [10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40, 50, 60, 70, 45, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40,
                            50, 60, 70, 45
                        ],
                        color: '#4473C5',
                    },
                        {
                            name: '上门率',
                            type: 'bar',
                            data: [10, 20, 30, 40, 50, 60, 70, 40, 50, 60, 70, 10, 20, 30, 40, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40,
                                50, 60, 70, 45
                            ],
                            color: '#ED7D31'
                        },
                        {
                            name: '签约率',
                            type: 'bar',
                            data: [10, 20, 30, 40, 50, 60, 70, 40, 50, 60, 70, 10, 20, 30, 40, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40,
                                50, 60, 70, 45
                            ],
                            color: '#A5A5A5'
                        },
                        {
                            name: '放款率',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [10, 20, 30, 40, 50, 60, 70, 40, 50, 10, 70, 10, 10, 30, 40, 10, 20, 30, 40, 10, 10, 70, 10, 20, 30, 40,
                                50, 60, 70, 45
                            ],
                            color: '#FCCE3B'
                        },
                        {
                            name: '业绩',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [10, 20, 30, 40, 50, 60, 70, 40, 50, 60, 70, 10, 20, 30, 40, 10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40,
                                50, 60, 70, 45
                            ],
                            color: '#468ECD'
                        }
                    ],
                },
                
                // 上门分析
                optionCompare: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        formatter: function (params) {
                            var htmlStr = '';
                            htmlStr += '<div><span style="color:#fff;">' + params[0].name + '</span><br/> ';
                            for (var i = 0; i < params.length; i++) {
                                //前面的原点和他的颜色
                                htmlStr += '<span style="width: 8px;height: 8px;display:inline-block;border-radius: 50%;background-color:' + params[i].color + '"></span><span style="color:#fff;">' + params[i].seriesName + ':</span>' +
                                    '<span style="color:#fff;">' + params[i].value + '&nbsp;%</span><br/>';
                            }
                            htmlStr += '</div>';
                            return htmlStr
                        },
                    },
                    legend: {
                        data: ['上门率', '公司平均上门率'],
                        top: ''
                    },
                    xAxis: [{
                        type: 'category',
                        data: ['1星客户', '2星客户', '2星+客户', '3星客户', '4星客户'],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value} %'
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    }
                    ],
                    series: [{
                        name: '上门率',
                        type: 'bar',
                        data: [12.33, 20, 30, 10, 50],
                        color: '#4372C4',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'black',
                                        fontSize: 16
                                    },
                                    formatter: function (params) {
                                        if (params.value) {
                                            return params.value + '%'
                                        } else {
                                            return '';
                                        }
                                    }
                                }
                            }
                        },
                    },
                        {
                            name: '公司平均上门率',
                            type: 'bar',
                            data: [10, 20, 30, 10, 50],
                            color: '#A4A4A4',
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 16
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    },

                                }
                            },
                        }
                    ],
                },


            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
        mounted() {
            this.timestampToTime(7)
            this.optionMy.xAxis[0].data = this.weekDayList
            // 上图
            this.table_th_list = this.weekDayList
			this.getList();
        },
        methods: {
			async getList() {
				let that = this;
				let data = {timePeriod: this.timePeriod, yearMonthList: this.yearMonthList, type: that.client_type, weekDayList: this.weekDayList}
				data.token = this.token;
				let res = await getDoorNums(that, data);
				that.optionMy.series[0].data = res.data.clientNums[0];
				that.optionMy.series[1].data = res.data.clientNums[1];
				that.optionMy.series[2].data = res.data.clientNums[2];
				that.optionMy.series[3].data = res.data.clientNums[3];
				that.optionMy.series[4].data = res.data.clientNums[4];
				let myChartOne = this.$echarts.init(document.getElementById("Mimelist2"));
				myChartOne.clear()
				myChartOne.setOption(this.optionMy);

				that.optionCompare.series[0].data = res.data.compareNums[0];
				that.optionCompare.series[1].data = res.data.compareNums[1];
				let myChartTwo = this.$echarts.init(document.getElementById("Mimelist3"));
				myChartTwo.clear()
				myChartTwo.setOption(this.optionCompare);
			},
            timePeriodClick(e) {
				if (e == '0') {
					this.timestampToTime(7)
					this.optionMy.dataZoom = false;
					this.optionMy.xAxis[0].data = this.weekDayList
					this.table_th_list = this.weekDayList
				} else if (e == '1') {
					this.timestampToTime(15)
					this.dataZoom[0].end = 50;
					this.optionMy.dataZoom = this.dataZoom;
					this.optionMy.xAxis[0].data = this.weekDayList
					this.table_th_list = this.weekDayList
				} else if (e == '2') {
					this.timestampToTime(30)
					this.dataZoom[0].end = 30;
					this.optionMy.dataZoom = this.dataZoom;
					this.optionMy.xAxis[0].data = this.weekDayList
					this.table_th_list = this.weekDayList
				} else if (e == '3') {
					this.timestampToMonth(12)
					this.optionMy.dataZoom = false;
					this.optionMy.xAxis[0].data = this.yearMonthList
					this.table_th_list = this.yearMonthList
				} else if (e == '4') {
					this.timestampToMonth(24)
					this.dataZoom[0].end = 50;
					this.optionMy.dataZoom = this.dataZoom;
					this.optionMy.xAxis[0].data = this.yearMonthList
					this.table_th_list = this.yearMonthList
				}
				this.getList();
            },
            timestampToTime(type) {
                // type =0 为当天 type = 1 为前一天
                // hhmmss 自己传需要的时分秒
                let now = new Date();
                let date
                if (type === 0) {
                    date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
                } else {
                    this.weekDayList = []
                    for (let i = 0; i < type; i++) {
                        let now = new Date();
                        date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
                        var time2 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate()+1);
                        this.weekDayList.unshift(time2)
                    }
                }
            },
            timestampToMonth(type) {

                let now = new Date();
                let year = now.getFullYear()
                this.yearMonthList = []
                if (type == 12) {
                    for (let i = 0; i < type; i++) {
                        let data
                        if (i + 1 < 10) {
                            data = year + '-0' + (i + 1)
                        } else {
                            data = year + '-' + (i + 1)
                        }

                        this.yearMonthList.push(data)
                    }
                } else if (type == 24) {
                    for (let i = 0; i < 12; i++) {
                        let data
                        if (i + 1 < 10) {
                            data = year + '-0' + (i + 1)
                        } else {
                            data = year + '-' + (i + 1)
                        }

                        this.yearMonthList.push(data)
                    }
                    for (let i = 12; i > 0; i--) {
                        let data
                        if (i < 10) {
                            data = (year - 1) + '-0' + (i)
                        } else {
                            data = (year - 1) + '-' + (i)
                        }

                        this.yearMonthList.unshift(data)
                    }

                }

            },
        }
    }
</script>

<style scoped lang="less">
    #Mimelist2 {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
        padding-top: 30px;
    }

    #Mimelist3 {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
        padding-top: 30px;
    }
</style>
